import { api } from "./api";

/** Which downstream apps each project is available in (served by the project service). */

export type AppAccess = "owner" | "shared";

export interface RegisteredApp {
  id: string;
  name: string;
}

export interface ProjectAppLink {
  app_id: string;
  access: AppAccess;
}

export interface ProjectAvailability {
  id: string;
  name: string;
  code: string;
  client_name: string;
  owner_app_id: string;
  apps: ProjectAppLink[];
  /** Project owner in the owning app, or a platform admin. The service enforces it either way. */
  can_manage: boolean;
}

export interface ProjectAvailabilityResponse {
  is_platform_admin: boolean;
  current_app_id: string;
  apps: RegisteredApp[];
  projects: ProjectAvailability[];
}

export const projectAvailabilityApi = {
  list: (): Promise<ProjectAvailabilityResponse> => api.get<ProjectAvailabilityResponse>("/api/project-availability"),

  share: (projectId: string, appId: string): Promise<ProjectAppLink[]> =>
    api.post<ProjectAppLink[]>(`/api/project-availability/${projectId}/apps`, { app_id: appId }),

  unshare: (projectId: string, appId: string): Promise<ProjectAppLink[]> =>
    api.delete<ProjectAppLink[]>(`/api/project-availability/${projectId}/apps/${appId}`),
};
